module.exports = require("./ms-SG.js");